<app-layer-button
  class="position-absolute bottom-7 start-5 z-2"
  (visibilityToggled)="toggleLayerSwitchVisibility()"
>
</app-layer-button>

<div class="position-absolute bottom-20 start-5 z-2 pt-2" [class.d-none]="!isLayerSelectionVisible">
  <app-layer-config (closed)="close()">
    <div #categoriesScroll class="categories-scroll" [class.has-overflow]="hasOverflow()">
      <div #categoriesContent class="d-flex flex-column categories">
        <app-sign-types-filter-data [appPath]="AppPaths.Internal"></app-sign-types-filter-data>

        <app-property-filters-data [appPath]="AppPaths.Internal"></app-property-filters-data>

        <app-observations-data
          *hasPermissionAny="[Permissions.VZO_Observations_Read]"
          [providerInfo$]="this.providerInfo$"
        >
        </app-observations-data>
        <app-clustered-signs-data></app-clustered-signs-data>
        <app-rollouts-tile-data></app-rollouts-tile-data>
        <app-trip-statistics-data> </app-trip-statistics-data>
        <app-construction-sites-data
          *hasPermissionAny="[Permissions.VZO_ConstructionSites_Read]"
        ></app-construction-sites-data>
      </div>
    </div>
  </app-layer-config>
</div>
